"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyEmailRequestDto = void 0;
class VerifyEmailRequestDto {
}
exports.VerifyEmailRequestDto = VerifyEmailRequestDto;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmVyaWZ5RW1haWxSZXF1ZXN0RHRvLmpzIiwic291cmNlUm9vdCI6Ii4vc3JjLyIsInNvdXJjZXMiOlsicGFja2FnZXMvbW9kZWxzL2R0by92ZXJpZnlFbWFpbFJlcXVlc3REdG8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsTUFBYSxxQkFBcUI7Q0FHakM7QUFIRCxzREFHQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBWZXJpZnlFbWFpbFJlcXVlc3REdG97XG4gICAgZW1haWw6IHN0cmluZztcbiAgICBjb2RlOiBzdHJpbmc7XG59Il19